module.exports = __webpack_public_path__ + "img/Infografis_ID_03.4d15f744.jpg";